import { useTranslation } from '../i18n'
import SEO from '../components/SEO'
import './PrivacyPage.css'

function PrivacyPage() {
  const { t } = useTranslation()

  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Learn how Intervio handles your data. Choose cloud or local processing for STT and OCR. No long-term session data stored."
        path="/privacy"
      />
      <section className="privacy-hero">
        <div className="container">
          <h1>{t('privacyPageTitle')}</h1>
          <p className="last-updated">{t('privacyLastUpdated')}</p>
        </div>
      </section>

      <section className="section privacy-content">
        <div className="container">
          <div className="privacy-document">
            <div className="privacy-intro">
              <p>{t('privacyIntro')}</p>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyArchitectureTitle')}</h2>
              <p>{t('privacyArchitectureIntro')}</p>
              <ul>
                <li><strong>Audio Processing:</strong> {t('privacyArchAudio')}</li>
                <li><strong>Screen Capture:</strong> {t('privacyArchScreen')}</li>
                <li><strong>Text Processing:</strong> {t('privacyArchText')}</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyDataTitle')}</h2>
              
              <h3>{t('privacyDataLocalTitle')}</h3>
              <ul>
                <li>{t('privacyDataLocal1')}</li>
                <li>{t('privacyDataLocal2')}</li>
                <li>{t('privacyDataLocal3')}</li>
                <li>{t('privacyDataLocal4')}</li>
              </ul>

              <h3>{t('privacyDataSentTitle')}</h3>
              <ul>
                <li>{t('privacyDataSent1')}</li>
                <li>{t('privacyDataSent2')}</li>
                <li>{t('privacyDataSent3')}</li>
              </ul>

              <h3>{t('privacyDataLocalOnlyTitle')}</h3>
              <ul>
                <li>{t('privacyDataLocalOnly1')}</li>
                <li>{t('privacyDataLocalOnly2')}</li>
                <li>{t('privacyDataLocalOnly3')}</li>
              </ul>

              <h3>{t('privacyDataNotTitle')}</h3>
              <ul>
                <li>{t('privacyDataNot1')}</li>
                <li>{t('privacyDataNot2')}</li>
                <li>{t('privacyDataNot3')}</li>
                <li>{t('privacyDataNot4')}</li>
                <li>{t('privacyDataNot5')}</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyUsageTitle')}</h2>
              <p>{t('privacyUsageIntro')}</p>
              <ul>
                <li>{t('privacyUsage1')}</li>
                <li>{t('privacyUsage2')}</li>
                <li>{t('privacyUsage3')}</li>
              </ul>
              <p>{t('privacyUsageNote')}</p>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyRetentionTitle')}</h2>
              <p><strong>Session Data:</strong> {t('privacyRetentionSession')}</p>
              <p><strong>Account Data:</strong> {t('privacyRetentionAccount')}</p>
              <p><strong>Analytics:</strong> {t('privacyRetentionAnalytics')}</p>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyThirdPartyTitle')}</h2>
              <p>{t('privacyThirdPartyIntro')}</p>
              <ul>
                <li>{t('privacyThirdParty1')}</li>
                <li>{t('privacyThirdParty2')}</li>
                <li>{t('privacyThirdParty3')}</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>{t('privacySecurityTitle')}</h2>
              <p>{t('privacySecurityIntro')}</p>
              <ul>
                <li>{t('privacySecurity1')}</li>
                <li>{t('privacySecurity2')}</li>
                <li>{t('privacySecurity3')}</li>
                <li>{t('privacySecurity4')}</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyChildrenTitle')}</h2>
              <p>{t('privacyChildrenText')}</p>
            </div>

            <div className="privacy-section">
              <h2>{t('privacyChangesTitle')}</h2>
              <p>{t('privacyChangesText')}</p>
            </div>

            <div className="privacy-summary">
              <h3>{t('privacySummaryTitle')}</h3>
              <div className="summary-grid">
                <div className="summary-item positive">
                  <span className="summary-icon">✓</span>
                  <span>{t('privacySummary1')}</span>
                </div>
                <div className="summary-item positive">
                  <span className="summary-icon">✓</span>
                  <span>{t('privacySummary2')}</span>
                </div>
                <div className="summary-item positive">
                  <span className="summary-icon">✓</span>
                  <span>{t('privacySummary3')}</span>
                </div>
                <div className="summary-item positive">
                  <span className="summary-icon">✓</span>
                  <span>{t('privacySummary4')}</span>
                </div>
                <div className="summary-item negative">
                  <span className="summary-icon">✗</span>
                  <span>{t('privacySummary5')}</span>
                </div>
                <div className="summary-item negative">
                  <span className="summary-icon">✗</span>
                  <span>{t('privacySummary6')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PrivacyPage
